import type { ApolloClient } from '@apollo/client';

type ModifyCachedNotificationGroupsCount = {
  accountId: string;
  client: ApolloClient<any>;
  timestamp: string | null;
  totalCount: number | undefined;
};

/**
 * @description The `modifyCachedNotificationGroupsCount` modifies the field of
 * the `GetUnopenedNotificationGroupsCount` query (`timestamp` and `totalCount`)
 * without affecting the already cached results from `GetNotificationGroups`
 * query.
 *
 * @param {string} accountId - the account id.
 * @param {ApolloClient<any>} client - the Apollo client.
 * @param {string | null} timestamp - the new `timestamp` to insert into the cache.
 * @param {number} totalCount - the new notifications count to insert into the cache.
 */
export function modifyCachedNotificationGroupsCount({
  accountId,
  client,
  timestamp,
  totalCount,
}: ModifyCachedNotificationGroupsCount) {
  client.cache.modify({
    fields: (value, { fieldName }) => {
      if (fieldName === 'notificationGroups') {
        return {
          ...value,
          timestamp,
          totalCount,
        };
      }
      return value;
    },

    id: client.cache.identify({
      __typename: 'Account',
      id: accountId,
    }),
  });
}
